
export const CONTRACTOR_SIDEBAR_CONSTANTS = {
    ITEM_HEIGHT: 72,
    PADDING_BUFFER: 12, 
    MIN_ITEMS: 1,
    
    RESIZE_DEBOUNCE_DELAY: 100, 
    INITIAL_CALCULATION_DELAY: 100, 
    
    FAST_PAGE_JUMP: 5, 
    
    TITLE: 'Contractors Pending Validation',
    SEARCH_PLACEHOLDER: 'Search Contractors...',
    
    PAGINATION_BUTTON: {
      MIN_WIDTH: '36px',
      PADDING_X: 1
    },
    
    AVATAR: {
      WIDTH: 40,
      HEIGHT: 40,
      MARGIN_RIGHT: 1.5
    },
    
    SEARCH_FIELD: {
      MARGIN_BOTTOM: 1,
      BORDER_RADIUS: 3,
      PADDING: 1
    }
  } as const;

export const CONTRACTOR_MANAGEMENT_CONSTANTS = {
  CONTAINER_HEIGHT: '95vh',
  SNACKBAR_DURATION: 6000,
  
  // Document statuses
  DOCUMENT_STATUS: {
    APPROVED: 1,
    REJECTED: 2,
    PENDING: 3
  },
  
  // Messages
  MESSAGES: {
    DOCUMENT_UPDATED_SUCCESS: 'Document updated status successfully.',
    CONTRACTOR_VERIFIED_SUCCESS: 'Contractor verified successfully.',
    DOCUMENT_STATUS_UPDATED_SUCCESS: 'Document status updated successfully.',
    NO_CONTRACTOR_SELECTED: 'Select a contractor to view details'
  }
} as const;